export default[
    {
        path: '/folhar/cadastro',
        name: 'cadastro', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/folhar/aplicativo/lista/:id',
        name: 'lista de trabalhadores no aplicativo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/folhar/editar/:id',
        name: 'lista', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]